import React from 'react';

interface Props {
  navID: string;
  title: string;
}

// eslint-disable-next-line react/prefer-stateless-function
class Section extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <div className="protocol-section" id={`proto-${this.props.navID}`}>
        <h2>{this.props.title}</h2>
        {this.props.children}
      </div>
    );
  }
}

export default Section;
